import { create } from 'zustand'

import {
  getWeeklyBreakdown,
  distributeBilling,
  resetClient,
  getLastDistributionValues,
  getServiceGrouping,
  getServiceDescriptions,
  createNewService,
  editService,
  removeService,
  removeSelectedServices,
  getOtherServices,
  createNewOtherService,
  editOtherService,
  removeOtherService
} from './provider'

import type { ClientModalProps } from './types'

export const useClientModal = create<ClientModalProps>((set) => ({
  weeklyBreakdownData: null,
  setWeeklyBreakdownData: (value) => set({ weeklyBreakdownData: value }),

  isWeeklyBreakdownLoading: false,
  setIsWeeklyBreakdownLoading: (value) => set({ isWeeklyBreakdownLoading: value }),

  isDistributeBillingLoading: false,
  setIsDistributeBillingLoading: (value) => set({ isDistributeBillingLoading: value }),

  isResetClientLoading: false,
  setIsResetClientLoading: (value) => set({ isResetClientLoading: value }),

  lastDistributionValuesData: null,
  setLastDistributionValuesData: (data) => set({ lastDistributionValuesData: data }),

  serviceGroupingData: [],
  setServiceGroupingData: (data) => set({ serviceGroupingData: data }),

  isServiceGroupingLoading: false,
  setIsServiceGroupingLoading: (value) => set({ isServiceGroupingLoading: value }),

  serviceDescriptionsData: [],
  setServiceDescriptionsData: (data) => set({ serviceDescriptionsData: data }),

  isServiceDescriptionsLoading: false,
  setIsServiceDescriptionsLoading: (value) => set({ isServiceDescriptionsLoading: value }),

  isCreateNewServiceLoading: false,
  setIsCreateNewServiceLoading: (value) => set({ isCreateNewServiceLoading: value }),

  isRemoveServiceLoading: false,
  setIsRemoveServiceLoading: (value) => set({ isRemoveServiceLoading: value }),

  isRemoveSelectedServicesLoading: false,
  setIsRemoveSelectedServicesLoading: (value) => set({ isRemoveSelectedServicesLoading: value }),

  isLastDistributionValuesLoading: false,
  setIsLastDistributionValuesLoading: (value) => set({ isLastDistributionValuesLoading: value }),

  otherServicesData: null,
  setOtherServicesData: (data) => set({ otherServicesData: data }),

  isOtherServicesLoading: false,
  setIsOtherServicesLoading: (value) => set({ isOtherServicesLoading: value }),

  isCreateNewOtherServiceLoading: false,
  setIsCreateNewOtherServiceLoading: (value) => set({ isCreateNewOtherServiceLoading: value }),

  isRemoveOtherServiceLoading: false,
  setIsRemoveOtherServiceLoading: (value) => set({ isRemoveOtherServiceLoading: value }),

  getWeeklyBreakdown,
  distributeBilling,
  resetClient,
  getLastDistributionValues,
  getServiceGrouping,
  getServiceDescriptions,
  createNewService,
  editService,
  removeService,
  removeSelectedServices,
  getOtherServices,
  createNewOtherService,
  editOtherService,
  removeOtherService
}))
